module.exports = {"StatusCode":200,"Payload":"[{\"location\":\"https://drz-websites.s3.us-west-2.amazonaws.com/some-file.mp3\"}]"}


//////////////////
// WEBPACK FOOTER
// ./src/payloads/aws/lambda/mocks/moveToOwnerBucket.json
// module id = ORmT
// module chunks = 0